import React, { useEffect, useRef, useState } from "react";
import { Container, Button, Row, Spinner } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import planetss from "../Assets/planet.png";
import { NFTGameInfo } from "../services/game_api";
import { getImage, GetType } from "../shared/common";

function Gameinfo({ gameinfotype, Contract, nftId }) {
  const type = gameinfotype;
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const getGameInfo = async (nftId) => {
      setLoading(true);
      try {
        const Resp = await NFTGameInfo({ type, nftId });
        console.log("getGameInfo", Resp);
        setState(Resp?.data || {});
      } catch (error) {
        console.error("getGameInfo", error);
      } finally {
        setLoading(false);
      }
    };
    if (nftId) getGameInfo(nftId);
  }, [Contract, nftId, type]);

  return (
    <>
      {loading ? (
        <div className="d-flex justify-content-center py-4">
          <Spinner animation="border" role="status" />
          <span className="ms-2 text-white">Loading...</span>
        </div>
      ) : (
        <>
          {type === "planet" || type === "astroid" ? (
            <>
              <div>
                {console.log("staxxxxxxxxxxxxxxxxxxte", state)}
                {state?.asset?.length > 0 ? (
                  <h4 className="text-white">Assets</h4>
                ) : (
                  <></>
                )}
                <Row>
                  {state?.asset?.length &&
                    state?.asset?.map((e) => (
                      <>
                        <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                          <div className="">
                            {console.log("sdohasdhashd", e)}
                            {/* <p className="text-white mb-1"><span className="themeclr">Image :</span> </p> */}
                            <img
                              src={getImage(e.image)}
                              className="img-fluid gameimgset"
                              alt="img"
                            />
                          </div>
                          <p className="text-white">
                            <span className="themeclr">Name :</span> {e.name}
                          </p>
                          <p className="text-white">
                            <span className="themeclr">Level :</span> {e.level}
                          </p>
                        </div>
                      </>
                    ))}
                </Row>
              </div>

              <div className="mt-3">
                {console.log("staxxxxxxxxxxxxxxxxxxte", state)}
                {state.data?.planetId?.slots?.length > 0 ? (
                  <h4 className="text-white mb-3">Slots</h4>
                ) : (
                  <></>
                )}
                <Row>
                  {state.data?.planetId?.slots?.length &&
                    state.data?.planetId?.slots?.map((e) => (
                      <>
                        <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                          {/* <p className="text-white"><span className="themeclr">{e.type}:</span> {state.data.planetId.rarity}</p> */}
                          {/* <p className="text-white"><span className="themeclr">Level :</span> {e.level}</p>  */}
                          <p className="text-white">
                            <span className="themeclr">{e.type}:</span> {e.slot}
                          </p>
                        </div>
                      </>
                    ))}
                </Row>
              </div>
            </>
          ) : (
            <div>
              <div className="">
                <p className="text-white mb-1">
                  <span className="themeclr">Image :</span>{" "}
                </p>
                <img
                  src={planetss}
                  className="img-fluid gameimgset"
                  alt="img"
                />
              </div>
              <p className="text-white">
                <span className="themeclr">Name :</span> Colony
              </p>
              <p className="text-white">
                <span className="themeclr">Level :</span> Colony
              </p>
            </div>
          )}
        </>
      )}
    </>
  );
}

export default Gameinfo;
